(() => {
  const pending = new WeakMap();
  const syncGift = (wrap) => {
    const message = document.getElementById(wrap.getAttribute('aria-controls'));
    if (!message) return;
    message.hidden = !wrap.checked;
    message.querySelector('textarea').disabled = !wrap.checked;
    wrap.setAttribute('aria-expanded', String(wrap.checked));
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-kc-wrap]')) syncGift(event.target);
  });
  const enhance = () => document.querySelectorAll('[data-kc-wrap], [data-kc-variant]').forEach(field => { field.disabled = false; if (field.matches("[data-kc-wrap]")) syncGift(field); });
  enhance();
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('change', async (event) => {
    if (!event.target.matches('[data-kc-variant]')) return;
    const select = event.target;
    const info = select.closest('product-info');
    pending.get(info)?.abort();
    const controller = new AbortController();
    pending.set(info, controller);
    const previousDisabled = info.productForm.submitButton.disabled;
    const previous = info.querySelector('.product-variant-id').value;
    info.resetProductFormState();
    info.setAttribute('aria-busy', 'true');
    const url = new URL(info.dataset.url, location.origin);
    url.searchParams.set('variant', select.value);
    url.searchParams.set('section_id', info.dataset.section);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Variant fetch failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!html.querySelector('[data-selected-variant]')) throw new Error('Variant missing');
      info.handleUpdateProductInfo(info.dataset.url)(html);
      select.focus({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError') return;
      select.value = previous;
      info.productForm.handleErrorMessage(window.kcStrings.networkError);
      info.productForm.toggleSubmitButton(previousDisabled, previousDisabled ? window.variantStrings.soldOut : undefined);
    } finally {
      if (pending.get(info) === controller) info.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#menu-drawer a');
    if (link) { const drawer = link.closest('header-drawer'); drawer?.closeMenuDrawer(event, drawer.querySelector('summary')); }
  });
  class KCStickyCart extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.main = this.info.querySelector('.product-form__submit');
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => {
        if (!this.main.disabled && this.main.getAttribute('aria-disabled') !== 'true') this.main.click();
      });
      this.updateVisibility = () => { this.hidden = this.main.getBoundingClientRect().bottom > 0; };
      this.observer = new IntersectionObserver(this.updateVisibility);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      this.updateVisibility();
      this.observer.observe(this.main);
      this.mutations = new MutationObserver(() => this.sync());
      this.mutations.observe(this.main, { attributes: true, childList: true, subtree: true });
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const priceContainer = data.html.getElementById(`price-${data.sectionId}`);
        const price = priceContainer?.querySelector('.price--on-sale .price-item--sale') || priceContainer?.querySelector('.price__regular .price-item--regular');
        if (price) this.querySelector('[data-kc-sticky-price]').textContent = price.textContent.trim();
        this.sync();
      });
      this.sync();
    }
    sync() {
      this.button.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true';
      this.button.textContent = this.main.querySelector('span').textContent.trim();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.updateVisibility); this.observer?.disconnect(); this.mutations?.disconnect(); this.unsubscribe?.(); }
  }
  if (!customElements.get('kc-sticky-cart')) customElements.define('kc-sticky-cart', KCStickyCart);
})();
